import axioPath from '../../../api/axioPath';

export const userChatList = (id) => () => {
    const token = localStorage.getItem("token")
    return axioPath.get(`/user/chatMessageThreadByUserID?userId=${id}`, {
        headers: {
            Authorization: token,
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((ex) => {
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};

export const userSendMessage = (data) => () => {
    const token = localStorage.getItem("token")
    return axioPath.post('/user/chatMessage', data, {
        headers: {
            Authorization: token,
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((ex) => {
            return ex;
        });
};

export const makeMessagesRead = (userAuthId) => () => {
    const token = localStorage.getItem("token")
    return axioPath.post(`/user/chatMessageThreadUpdateReadBy?userId=${userAuthId}&userType=USER`, {}, {
        headers: {
            Authorization: token,
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((ex) => {
            return ex;
        });
};